import antdEnUS from 'ant-design-vue/es/locale-provider/en_US';
import momentEU from 'moment/locale/eu';

import menu from './menu';
import workplace from './workplace';

import systemAdmin from './system/admin';

const components = {
  antLocale: antdEnUS,
  momentName: 'en',
  momentLocale: momentEU
}

export default {
  message: '-',

  ...components,
  ...menu,
  ...workplace,
  ...systemAdmin
}